import { Controller } from "@hotwired/stimulus"
import { Dropdown } from "bootstrap"

// Connects to data-controller="dropdown"
export default class extends Controller {
  connect() {
    this.initializeDropdowns()
  }

  initializeDropdowns() {
    // Find all dropdown toggles in this element
    const dropdownToggles = this.element.querySelectorAll('.dropdown-toggle')
    
    dropdownToggles.forEach(toggle => {
      // Only initialize if not already initialized
      if (!toggle._dropdown) {
        toggle._dropdown = new Dropdown(toggle)
      }
    })
  }

  disconnect() {
    // Clean up dropdown instances when controller disconnects
    const dropdownToggles = this.element.querySelectorAll('.dropdown-toggle')
    
    dropdownToggles.forEach(toggle => {
      if (toggle._dropdown) {
        toggle._dropdown.dispose()
        delete toggle._dropdown
      }
    })
  }
}
